<!--
  A ElCodeInput with its validator
  Has the properties of both ElFormSmallItem and ElCodeInput
-->

<template>
  <el-form-small-item
    :prop="prop"
    :required="required && type !== 'json'"
    :rules="computedRules"
    :error="error"
    :validateStatus="validateStatus"
    :inlineMessage="inlineMessage"
    :showMessage="showMessage"
    :size="size"
    :flex="flex"
    :field="field">
    <el-code-input ref="input"
      :value="value"
      :type="type"
      :disabled="disabled"
      :tabindex="tabindex"
      v-bind="$attrs"
      v-on="$listeners"
      @valid="(val) => valid = val">
    </el-code-input>
  </el-form-small-item>
</template>

<script>
import ElCodeInput from './ElCodeInput.vue'
import ElFormSmallItem from './ElFormSmallItem.vue'

export default {
  name: 'ElFormItemCodeInput',
  components: {
    ElCodeInput,
    ElFormSmallItem,
  },
  props: {
    value: {},
    type: String,
    prop: String,
    required: {
      type: Boolean,
      default: undefined,
    },
    rules: [Object, Array],
    error: String,
    validateStatus: String,
    inlineMessage: {
      type: [String, Boolean],
      default: true,
    },
    showMessage: {
      type: Boolean,
      default: false,
    },
    size: String,
    flex: {
      type: Boolean,
      default: true,
    },
    field: {
      type: String,
      default: 'script',
    },
    disabled: Boolean,
    tabindex: {
      type: [String, Number],
      default: '0',
    },
  },
  data () {
    return {
      valid: {
        type: Boolean,
        default: true,
      },
    }
  },
  computed: {
    computedRules () {
      let out = []
      if (this.required && this.type === 'json') {
        out.push({
          validator: (rule, value, callback) => callback(value === undefined
            ? new Error(this.field + ' is required') : undefined),
          trigger: 'blur',
        })
      }
      out.push({
        validator: (rule, value, callback) => callback(this.disabled ||
          this.valid ? undefined : new Error('script error')),
        trigger: 'submit',
      })
      return out.concat(this.rules || [])
    },
  },
  methods: {
    focus () { this.$refs.input.focus() },
    clear () { this.$refs.input.clear() },
  },
}
</script>
